<template>
    <div class="ui centered grid">
        <div class="sixteen wide column ">
            <div class="ui items" style="padding:10px">
              <!--  <div class="item" v-for="user in usersList" :key="user.uuid" v-on:click="userDetails(user.uuid)" style="cursor:pointer">-->
                    <div class="divTable">
                        <div class="divTableBody">
                            <div  v-for="user in usersList" :key="user.uuid" class="divTableRow">
                                <div class="divTableCell" style="width:30%;font-weight: bold;">{{user.first_name}} {{user.last_name}}</div>
                                <div class="divTableCell" style="width:30%">{{user.username}}</div>
                                <div class="divTableCell" style="width:15%">{{user.role}}</div>
                                <div class="divTableCell" style="width:5%"><div style="width:50%;height:100%;" v-bind:style="{'background-color':user.notes_color}">&nbsp;</div></div>
                                <div class="divTableCell" style="width:20%;text-align: right;"><button class="mini ui blue button" v-on:click="$emit('editUser',user.uuid)">Edit</button> <button class="mini ui red button" v-on:click="$emit('deleteUser',user.uuid)">Delete</button></div>
                            </div>
                        </div>
                    </div>
               <!-- </div>-->
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['usersList'],
        data() {
            return {
                user_mgs:"This ugly user"
            }
        },
        methods: {

        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .divTable {
        display: table;
        width: 100%;

    }

    .divTableRow {
        display: table-row;
    }

    .divTableHeading {
        background-color: #EEE;
        display: table-header-group;
    }

    .divTableCell,
    .divTableHead {
        border-bottom: 1px solid #999999;
        display: table-cell;
        padding: 10px 0px 10px 0px;
    }

    .divTableHeading {
        background-color: #EEE;
        display: table-header-group;
        font-weight: bold;
    }

    .divTableFoot {
        background-color: #EEE;
        display: table-footer-group;
        font-weight: bold;
    }

    .divTableBody {
        display: table-row-group;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheUserList.vue